exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clients-list-page .content-client-list{position:relative}.clients-list-page .btn-new-client{position:absolute;right:10px;top:40px}.clients-list-page .content-list-table{margin-top:60px}.clients-list-page.mobile .header-filter-components{margin:30px 0 0 0}.clients-list-page.mobile .content-list-table{margin-top:10px}.clients-list-page.mobile .btn-new-client{right:0;top:0}", ""]);

// exports
